module.exports = __webpack_public_path__ + "static/img/comtop-two.1e5f4da.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/comtop-two.png
// module id = P38n
// module chunks = 0